import React from 'react';
import moment from 'moment';
import {
  Button, Grid, TextField,
  Dialog, DialogActions,
  DialogContent, DialogContentText,
  FormControl, Input, InputLabel, makeStyles
} from '@material-ui/core';
import {
  KeyboardDateTimePicker
} from '@material-ui/pickers';
import KenColors from '../../../Utils/themes/KenColors';
import KenButton from "../../../global_components/KenButton/index"
import { FiCheck } from "react-icons/fi";
import KenFileUpload from "../../../Components/KenFileUpload"
import { useTranslation } from 'react-i18next';
import { dateFormate, dateTimeFormate } from '../../../Utils/constants'


const useStyles = makeStyles((theme) => ({
  eventTitle: {
    background: KenColors.eventTitleBackgroundColor,
    padding: 10,
    fontWeight: 600,
    color: KenColors.eventTitleColor
  },
  imageGrid:{
    display: "flex"
  },
  imageGridButton: {
    height: "54px",
    backgroundColor: KenColors.primary,
    color: KenColors.kenWhite,
    boxShadow: "none",
    borderRadius: "0%",
    '&:hover': {
      backgroundColor: KenColors.primary,
      color: KenColors.kenWhite,
    },
  },

}));

const CreateEvent = ({ open, setOpen, createEvent, eventData, updateEventDetails }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [startDate, setStartDate] = React.useState(new Date());
  const [startTime, setStartTime] = React.useState(new Date());
  const [endDate, setEndDate] = React.useState(new Date());
  const [endTime, setEndTime] = React.useState(new Date());
  const [subject, setSubject] = React.useState('');
  const [location, setLocation] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [currentDate, setCurrentDate] = React.useState(new Date());
  const [submit, setSubmit] = React.useState(false);
  const [fileName, setFileName] = React.useState('');
  const [fileDetails, setFileDetails] = React.useState(null);
  const [fileError, setFileError] = React.useState(false);
  const [imageError, setImageError] = React.useState('');








  const handleDateChange = (date, v) => {
    switch (v) {
      case 1:
        setStartDate(date);
        break;
      case 2:
        setEndDate(date);
        break;
      default:
        break;
    }
  };

  const createEventHandler = async () => {
    setSubmit(true);
    if (subject !== '' && description !== '') {
      setSubmit(false);
      const sDate = moment(startDate).format(dateFormate);
      const eDate = moment(endDate).format(dateFormate);
      const sTime = moment(startDate).format(dateTimeFormate);
      const eTime = moment(endDate).format(dateTimeFormate);
      const payload = {
        Subject: subject,
        Description: description,
        Location: location,
        StartDateTime: moment(sDate + ' ' + sTime).format(),
        EndDateTime: moment(eDate + ' ' + eTime).format(),
      }
      if (eventData != null) {
        const updatePayload = {
          ...payload,
          ID: eventData.Id
        }
        updateEventDetails(updatePayload, fileDetails)
      } else {
        createEvent(payload, fileDetails);

      }
      handleClose();
    }

  }
  const handleClose = () => {
    setOpen(false);
  };

  const getExt = (filepath) => {
    return filepath.split("?")[0].split("#")[0].split('.').pop();
}


  const handleFileUpload = (event) => {

    const fileDetails = event.target.files[0];
    const fileExt = (getExt(fileDetails.name)).toLowerCase();
    
    if(fileExt === 'jpeg' || fileExt === 'jpg' || fileExt === 'png' || fileExt === 'gif'){
      if(fileDetails.size > 300000){
        setImageError("*Image should not exceed 300kb")
        setFileError(true);

      }else {
        setFileName(fileDetails.name);
        setFileDetails(fileDetails);
      }
      
    }else {
      setImageError("*Upload JPEG, PNG, GIF file")
      setFileError(true);
    }
  }


  React.useEffect(() => {
    if (eventData != null) {
      setStartDate(new Date(eventData.StartDateTime));
      setStartTime(new Date(eventData.StartDateTime));
      setEndDate(new Date(eventData.EndDateTime));
      setEndTime(new Date(eventData.EndDateTime));
      setSubject(eventData.Subject);
      setLocation(eventData.Location);
      setDescription(eventData.Description);
      setCurrentDate(new Date(eventData.StartDateTime));
      if(eventData.Image.length > 0){
        setFileName(eventData.Image[0].Name);
      }
    }
  }, []);


  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth={true} aria-labelledby="form-dialog-title">
      <DialogContent className="create_event_modal">
        <DialogContentText className={classes.eventTitle} >
        { (eventData === null) ? t("labels:Add_New_Event") : t("labels:Edit_Event")}
          </DialogContentText>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              id="outlined-basic"
              placeholder={t("labels:Event Title")}
              value={subject}
              variant="outlined"
              onChange={(e) => setSubject(e.target.value)}
              error={(submit && subject === '') ? true : false}
              helperText={(submit && subject === '') ? "Required field" : ''}
            />


          </Grid>
     <Grid item xs={12}>
          <TextField
              
              id="outlined-basic"
              placeholder="Enter Location"
              variant="outlined"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
            />
          </Grid>

          <Grid item xs={6} >
            <KeyboardDateTimePicker
              margin="normal"
              id="date-picker-dialog"
              placeholder={t("labels:start_date")}
              format="MM/DD/yyyy hh:mm a"
              value={startDate}
              minDate={currentDate}
              variant="outlined"
              onChange={(e) => handleDateChange(e, 1)}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </Grid>
          

          <Grid item xs={6} >
            <KeyboardDateTimePicker
              margin="normal"
              id="date-picker-dialog"
              variant="outlined"
              placeholder={t("labels:end_date")}
              format="MM/DD/yyyy hh:mm a"
              value={endDate}
              minDate={startDate}
              onChange={(e) => handleDateChange(e, 2)}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </Grid> 

          <Grid item xs={12} className={classes.imageGrid}>
          <Grid item xs={12}>
          <TextField
              id="outlined-basic"
              readonly
              placeholder={t("messages:No_File_Chosen")}
              value={fileName}
              variant="outlined"
              error={(fileError) ? true : false}
              helperText={(fileError) ? imageError : ''}
            /></Grid>
            <Grid xs={4}>
            <Button
              variant="contained"
              component="label"
              className={classes.imageGridButton}
            >
              {t("labels:Browse_file")}
              <input
                type="file"
                onChange={(e) => handleFileUpload(e)}
                hidden
              />
            </Button>

            </Grid>
          
          </Grid>

          <Grid item xs={12}>
            <TextField
              id="outlined-textarea"
              placeholder={t("labels:description")}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              multiline
              variant="outlined"
              error={(submit && description === '') ? true : false}
              helperText={(submit && description === '') ? "Required field" : ''}
            />
          </Grid>
        </Grid>


      </DialogContent>
      <DialogActions className="mr-2">
        <KenButton variant="outlined" onClick={handleClose} >
          {t("labels:cancel")}
        </KenButton>
        {eventData === null && <KenButton variant="contained" onClick={createEventHandler} color="primary">
          <FiCheck/>
          {t("labels:Add")}
        </KenButton>}
        {eventData != null && <KenButton variant="contained" onClick={createEventHandler} color="primary">
          {t("labels:update")}
        </KenButton>}
      </DialogActions>



    </Dialog>
  );
}

export default CreateEvent;